/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

import { AVATAR_SIZE_LARGE, AvatarSize } from '../Avatar';
import { SdsDivProps } from '../Component.props';
import { UserProfile } from './User.defs';

/**
 * The props for `<User />`.
 */
export interface UserProps extends SdsDivProps {
  /**
   * Avatar size.
   */
  avatarSize?: AvatarSize;

  /**
   * Choose to include an Avatar for the user.
   */
  displayAvatar?: boolean;

  /**
   * Choose to hide the whole name of the user.
   */
  hideName?: boolean;

  /**
   * Choose to hide the user's Avatar photo.
   */
  hidePhoto?: boolean;

  /**
   * Choose to hide the surname of the user.
   */
  hideSurname?: boolean;

  /**
   * User profile.
   */
  user: UserProfile;
}

/**
 * The default prop values for `<User />`.
 */
export const userDefaults = {
  avatarSize: AVATAR_SIZE_LARGE as AvatarSize,
  displayAvatar: true,
  hideName: false,
  hidePhoto: false,
  hideSurname: false,
};
